import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { tryGetErrorMessage } from './error.utils';
import { NotifyService } from './service/notify.service';

export class ServerErrorsInterceptor implements HttpInterceptor {
  private notifyService = inject(NotifyService);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // swallow these errors because we expect them sometimes
        if (error.status === 404 && (error.url.includes('camera-snapshots') || error.url.includes('Snapshot'))) return throwError(error);

        if (error.error instanceof Blob) {
          return from(error.error.text()).pipe(
            map((text) => new HttpErrorResponse({ ...error, error: JSON.parse(text) })),
            catchError(() => of(error)),
            tap((err) => this.notifyService.notify(tryGetErrorMessage(err))),
            mergeMap((err) => throwError(err)),
          );
        }

        this.notifyService.notify(tryGetErrorMessage(error));
        return throwError(error);
      }),
    );
  }
}
